<template>
    <div class="home-page-image-hover-block">
        <div class="image-animation" v-if="isShow">
            <div class="block-content" :class="[imageIndex === index ? 'show-img':'hidden-img']"  v-for="(item,index) in imageList">
                <img  :src="item.image" @mouseenter ="enterFun(index)"/>
                <div class="image-info">
                    <div class="image-title">{{item.title}} <div class="color-line"></div></div>
                    <div class="image-content" :class="[imageIndex === index ? 'show-text':'hidden-text']">{{item.info}}</div>
                </div>
            </div>
        </div>
<!--        移动端显示轮播-->
        <div class="carousel" v-else>
            <el-carousel :height="heightEl" indicator-position="none">
                <el-carousel-item v-for="(item,index) in imageList" :key="index">
                    <div class="list-image">
                        <div class="mark"></div>
                        <img :src="item.image"/>
                        <div class="show-info">
                            <div class="image-title">{{item.title}}</div>
                            <div class="image-content">{{item.info}}</div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
    import UseImageOne from '../../views/image/use_one.jpg'
    import UseImageTwo from '../../views/image/use_two.jpeg'
    import UseImageThree from '../../views/image/use_three.jpeg'
    import UseImageFour from '../../views/image/use_four.jpeg'
    import UseImageFive from '../../views/image/use_five.jpg'

    export default {
        name: "home-page-image-hover",
        props:{
          isShow:Boolean
        },
        data(){
            return{
                heightEl:'',
                imageList:[
                    {title:'校园',image:UseImageOne,info:'校园网站是基于学校单位建立的的校园官方网络平台，承载着信息化',showInfo:true},
                    {title:'工业',image:UseImageTwo,info:'根据客户需求制作出相应的网络平台，大大简化工厂实际操作流程，系统化管理信息。',showInfo:false},
                    {title:'建筑',image:UseImageThree,info:'基于互联网信息技术发展的，在其建设过程中以标准化、智能化、环保绿色化为基本要求。',showInfo:false},
                    {title:'监控',image:UseImageFour,info:'提拱了包括前端视频感知设备、网络传输设备、管理平台以及视频业务应用在内的端到端的整体解决方案。',showInfo:false},
                    {title:'城市',image:UseImageFive,info:'运用先进的科学技术，信息技术以及互联网的强大功能，对城市进行智能化、科技化的改造。',showInfo:false},
                ],
                imageIndex:0  //默认选中的图片
            }
        },
        watch:{
            '$store.state.screenWidth'(){
                this.changeHeight()
            }
        },
        mounted(){
            this.changeHeight()
        },
        methods:{
            /**
             * 切换图片
             */
            enterFun(index){
                let that = this;
                this.imageIndex = index;

            },
            /**
             * 改变轮播区域高度
             */
            changeHeight(){
                let productWidth = this.$store.state.screenWidth;
                this.heightEl = productWidth*1000/1920 + 'px';
                // console.log('productWidth',this.heightEl)
            },
        }

    }
</script>

<style lang="scss" src="./home-page-image-hover.scss" scoped></style>
